module.exports = __webpack_public_path__ + "img/Cienie.a59441b7.png";